import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { modalTypes } from "constants/types";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { setAnalysisAiEnabled } from "slices/generativeAi/actions";

const BODY_TEXT =
  "Analyses and outline generations that are currently running will be stopped. " +
  "Completed results are kept and stay available.";

const DisableAiFeatureModal = () => {
  const dispatch = useDispatch();

  const onDismiss = () => {
    dispatch(hideModal(modalTypes.DISABLE_AI_FEATURE_MODAL));
  };

  const onConfirm = () => {
    dispatch(hideModal(modalTypes.DISABLE_AI_FEATURE_MODAL));
    dispatch(setAnalysisAiEnabled(false));
  };

  return (
    <Modal className="fade-in" show onDismiss={onDismiss} backdrop centered>
      <Modal.Header>Turn Off AI Features?</Modal.Header>

      <Modal.Body>
        <p>{BODY_TEXT}</p>
      </Modal.Body>

      <Modal.Footer>
        <NewButton variant={NewButtonVariant.l2} onClick={onDismiss}>
          Cancel
        </NewButton>

        <NewButton variant={NewButtonVariant.l1} onClick={onConfirm}>
          Turn Off
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default DisableAiFeatureModal;
